// extracted by mini-css-extract-plugin
module.exports = {"card":"Card-module--card--3FjBB"};